import classes from './Banner.module.css';
import Section from '../../layout/Section';
import { Col } from 'react-bootstrap';
import laser_pega from '../../assets/laserpega.png';
import Noun from '../Noun';

const Banner = () => {
  return (
    <Section fullWidth={false} className={classes.bannerSection}>
      <Col lg={6}>
        <div className={classes.wrapper}>
          <h1>
            Defi
            <br />
            Meet
            <br />
            Peganomics
          </h1>
        </div>
      </Col>
      <Col lg={6}>
        <div style={{ padding: '2rem' }}>
          <Noun imgPath={laser_pega} alt="Pega" />
        </div>
      </Col>
    </Section>
  );
};

export default Banner;
